/** 切換完整月份，月底日期會收斂至目標月份最後一天。 */
export function shiftCalendarMonth(value: Date, offset: number) {
  const result = new Date(value);
  const day = result.getDate();
  result.setDate(1);
  result.setMonth(result.getMonth() + offset);
  result.setDate(Math.min(day, new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate()));
  return result;
}

/** 依當日邊界裁切時段，重疊群組分欄，相接時段可沿用同一欄。 */
export function layoutTeacherDay<T extends { startsAt: string; endsAt: string }>(items: T[], day: Date) {
  const start = new Date(day);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  const rows = items.map(item => ({ item, start: Math.max(+start, Date.parse(item.startsAt)), end: Math.min(+end, Date.parse(item.endsAt)), column: 0, columns: 1 }))
    .filter(row => Number.isFinite(row.start) && Number.isFinite(row.end) && row.end > row.start)
    .sort((a, b) => a.start - b.start || b.end - a.end);
  let group: typeof rows = [];
  let ends: number[] = [];
  let groupEnd = -Infinity;
  function finish() {
    for (const row of group) row.columns = ends.length;
    group = [];
    ends = [];
  }
  for (const row of rows) {
    if (row.start >= groupEnd) finish();
    let column = ends.findIndex(value => value <= row.start);
    if (column < 0) column = ends.length;
    ends[column] = row.end;
    row.column = column;
    group.push(row);
    groupEnd = Math.max(groupEnd, row.end);
  }
  finish();
  return rows;
}
